import { createContext,useState } from "react";

export const ColorContext = createContext()


export const ColorProvider = ({children}) => {
    const [color,setColor] = useState("#ec9131")
    document.documentElement.style.setProperty(
      '--color-primary',
      color
    );
  return (
    <ColorContext.Provider value={{color,setColor}}>
        {children}
    </ColorContext.Provider>
  )
}
